import { createSlice } from '@reduxjs/toolkit'

export const review = createSlice({
  name: 'review',
  initialState: {
    defaultCategory1: '',
    defaultCategory2: '',
    defaultTonality: '',
    defaultSentiment: '',
    template: '',
    reply: '',
    report: false
  },
  reducers: {
    setDefaultData: (state, item) => {
      state.defaultCategory1 = item.payload.category1
      state.defaultCategory2 = item.payload.category2
      state.defaultTonality = item.payload.tonality
      state.defaultSentiment = item.payload.sentiment
      state.template = item.payload.template
    },
    setReplyData: (state, item) => {
      state.reply = item.payload.reply
    },
    setReport: (state, item) => {
      state.report = item.payload
    }
  }
})

export const { setDefaultData, setReplyData, setReport } = review.actions
export default review.reducer